const speed = 2500;

// アニメーションを設定する関数
const setDrawAnimation = (path, delay = 0) => {
  const len = path.getTotalLength();
  const duration = len / speed;

  path.style.strokeDasharray = len;
  path.style.strokeDashoffset = len;
  path.style.animation = `drawLine ${duration}s linear ${delay}s forwards`;

  return duration;
};


// line-wrap01
const paths01 = document.querySelectorAll('.line-wrap .draw');

let delay01 = 0;
let firstDuration = 0;

paths01.forEach((path, index) => {
  const duration = setDrawAnimation(path, delay01);

  if (index === 0) {
    firstDuration = duration;
  }

  delay01 += duration;
});


// line-wrap02
const paths02 = document.querySelectorAll('.line-wrap02 .draw');

// 1本目が描き終わった0.2秒後に開始
const delay02 = Math.max(0, firstDuration + 0.3);

paths02.forEach(path => {
  setDrawAnimation(path, delay02);
});


jQuery(function ($) {
  $('.news-categorys').on('click', 'a', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const $a = $(this);
    const $li = $a.parent();
    const $listbox = $a.closest('.news-listbox');

    const $curr = $listbox.find('.news-list.active');
    const $next = $($a.data('target'));

    $listbox.find('.news-categorys a').removeClass('is-current');
    $a.addClass('is-current');

    if (!$next.length || $curr[0] === $next[0]) {
      return false;
    }

    $li.addClass('active').siblings().removeClass('active');

    $curr
      .removeClass('active')
      .stop(true, true)
      .fadeOut(200, function () {
        $next
          .stop(true, true)
          .hide()
          .addClass('active')
          .fadeIn(200);
      });

    return false;
  });
});
